import axios, {AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken} from 'axios';
import {SafeDigsClientBase, isAxiosError, throwException} from './SafeDigsClientBase';
import MNSwagClientConfiguration from '../Toolkit/Api/NSwagClientConfiguration';
import {MNullable} from '../Toolkit/Utils';
import {NoteCreateDto, SafeDigSendRequest} from './SafeDigsClients';

export class NoticeClient extends SafeDigsClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: MNSwagClientConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl('');

    }

    /**
     * @return Success
     */
    notice(id: number, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Notice/Notice{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotice(_response);
        });
    }

    protected processNotice(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404 !== undefined ? resultData404 : null as any;

            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    noticeHeader(id: number, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Notice/NoticeHeader{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNoticeHeader(_response);
        });
    }

    protected processNoticeHeader(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404 !== undefined ? resultData404 : null as any;

            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    noticeDetail(id: number, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Notice/NoticeDetail{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNoticeDetail(_response);
        });
    }

    protected processNoticeDetail(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404 !== undefined ? resultData404 : null as any;

            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    listNotices( filter?: number, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Notice";
        if(filter !== null && filter !== undefined) {
            url_ += `?filterNumber=${filter}`;
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListNotices(_response);
        });
    }

    /**
     * @return Success
     */
    listNoticeDetails(noticeId: number, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Notice/ListNoticeDetails/{noticeId}";
        if (noticeId === undefined || noticeId === null)
            throw new Error("The parameter 'noticeId' must be defined.");
        url_ = url_.replace("{noticeId}", encodeURIComponent("" + noticeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListNoticeDetails(_response);
        });
    }

    protected processListNoticeDetails(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    listSafeDigNotices(safedigId: number, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Notice/GetSafedigNotices/{safedigId}";
        url_ = url_.replace("{safedigId}", encodeURIComponent("" + safedigId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListNotices(_response);
        });
    }

    /**
     * @return Success
     */
    listSubNotices(parentId: number, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Notice/GetSubNotices/{parentId}";
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListNotices(_response);
        });
    }

    protected processListNotices(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateHeader(body: NoticeUpdateHeaderDto | undefined, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Notice/UpdateHeader";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateHeader(_response);
        });
    }

    protected processUpdateHeader(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as null;

            return Promise.resolve<any>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404 !== undefined ? resultData404 : null as null;

            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: NoticeCreateDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Notice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = resultData201 !== undefined ? resultData201 : null as any;

            return Promise.resolve<any>(result201);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: NoticeUpdateDto | undefined, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Notice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404 !== undefined ? resultData404 : null as any;

            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addNote(body: NoteCreateDto | undefined, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Notice/AddNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddNote(_response);
        });
    }

    protected processAddNote(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendFiles(body: SafeDigSendRequest | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Notice/SendFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendFiles(_response);
        });
    }

    protected processSendFiles(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class NoticeCreateDto implements INoticeCreateDto {
    odinId: string | undefined;
    safeDigId: number | undefined;
    parentId: number | undefined;
    address1: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    county: string | undefined;
    easting: number | undefined;
    northing: number | undefined;
    easting2: number | undefined;
    northing2: number | undefined;
    worksLocations: number[] | undefined;
    workDescription: string | undefined;
    requestor: string | undefined;
    startDate: MNullable<Date> | undefined;
    endDate: MNullable<Date> | undefined;
    tmType: number[] | undefined;
    fwClosureType: number | undefined;
    trafficSensitiveHours: number | undefined;
    hoursOfWork: string | undefined;
    excavationRequired: boolean | undefined;
    permitType: number | undefined;
    l2id?: string | undefined;
    project: number | undefined;
    subResource: number | undefined;

    constructor(data?: INoticeCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.odinId = _data["odinId"];
            this.safeDigId = _data["safeDigId"];
            this.parentId = _data["parentId"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.county = _data["county"];
            this.easting = _data["easting"];
            this.northing = _data["northing"];
            this.easting2 = _data["easting2"];
            this.northing2 = _data["northing2"];
            if (Array.isArray(_data["worksLocations"])) {
                this.worksLocations = [] as any;
                for (let item of _data["worksLocations"])
                    this.worksLocations!.push(item);
            }
            this.workDescription = _data["workDescription"];
            this.requestor = _data["requestor"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            if (Array.isArray(_data["tmType"])) {
                this.tmType = [] as any;
                for (let item of _data["tmType"])
                    this.tmType!.push(item);
            }
            this.fwClosureType = _data["fwClosureType"];
            this.trafficSensitiveHours = _data["trafficSensitiveHours"];
            this.hoursOfWork = _data["hoursOfWork"];
            this.excavationRequired = _data["excavationRequired"];
            this.permitType = _data["permitType"];
            this.l2id = _data["l2id"];
            this.project = _data["project"];
            this.subResource = _data["subResource"];
        }
    }

    static fromJS(data: any): NoticeCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoticeCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["odinId"] = this.odinId;
        data["safeDigId"] = this.safeDigId;
        data["parentId"] = this.parentId;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["county"] = this.county;
        data["easting"] = this.easting;
        data["northing"] = this.northing;
        data["easting2"] = this.easting2;
        data["northing2"] = this.northing2;
        if (Array.isArray(this.worksLocations)) {
            data["worksLocations"] = [];
            for (let item of this.worksLocations)
                data["worksLocations"].push(item);
        }
        data["workDescription"] = this.workDescription;
        data["requestor"] = this.requestor;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        if (Array.isArray(this.tmType)) {
            data["tmType"] = [];
            for (let item of this.tmType)
                data["tmType"].push(item);
        }
        data["fwClosureType"] = this.fwClosureType;
        data["trafficSensitiveHours"] = this.trafficSensitiveHours;
        data["hoursOfWork"] = this.hoursOfWork;
        data["excavationRequired"] = this.excavationRequired;
        data["permitType"] = this.permitType;
        data["l2id"] = this.l2id;
        data["project"] = this.project;
        data["subResource"] = this.subResource;
        return data;
    }
}

export class NoticeUpdateDto implements INoticeUpdateDto {
    id: number | undefined;
    odinId: string | undefined;
    safeDigId: number | undefined;
    parentId: number | undefined;
    address1: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    county: string | undefined;
    easting: number | undefined;
    northing: number | undefined;
    easting2: number | undefined;
    northing2: number | undefined;
    worksLocations: number[] | undefined;
    workDescription: string | undefined;
    requestor: string | undefined;
    startDate: MNullable<Date> | undefined;
    endDate: MNullable<Date> | undefined;
    tmType: number[] | undefined;
    fwClosureType: number | undefined;
    phaseType: number | undefined;
    cancelReason: number | undefined;
    cancelNote: string | undefined;
    permitNumber: string | undefined;
    submissionDate?: MNullable<Date> | undefined;
    permitStatus: number | undefined;
    trafficSensitiveHours: number | undefined;
    hoursOfWork: string | undefined;
    excavationRequired: boolean | undefined;
    noticeStatus: number | undefined;
    usrn?: string | undefined;
    permitType: number | undefined;
    l2id?: string | undefined;
    roadType: number | undefined;
    project: number | undefined;
    subResource: number | undefined;

    constructor(data?: INoticeUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.odinId = _data["odinId"];
            this.safeDigId = _data["safeDigId"];
            this.parentId = _data["parentId"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.county = _data["county"];
            this.easting = _data["easting"];
            this.northing = _data["northing"];
            this.easting2 = _data["easting2"];
            this.northing2 = _data["northing2"];
            if (Array.isArray(_data["worksLocations"])) {
                this.worksLocations = [] as any;
                for (let item of _data["worksLocations"])
                    this.worksLocations!.push(item);
            }
            this.workDescription = _data["workDescription"];
            this.requestor = _data["requestor"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            if (Array.isArray(_data["tmType"])) {
                this.tmType = [] as any;
                for (let item of _data["tmType"])
                    this.tmType!.push(item);
            }
            this.fwClosureType = _data["fwClosureType"];
            this.phaseType = _data["phaseType"];
            this.cancelReason = _data["cancelReason"];
            this.cancelNote = _data["cancelNote"];
            this.permitNumber = _data["permitNumber"];
            this.submissionDate = _data["submissionDate"];
            this.permitStatus = _data["permitStatus"];
            this.trafficSensitiveHours = _data["trafficSensitiveHours"];
            this.hoursOfWork = _data["hoursOfWork"];
            this.excavationRequired = _data["excavationRequired"];
            this.noticeStatus = _data["noticeStatus"];
            this.usrn = _data["usrn"];
            this.permitType = _data["permitType"];
            this.l2id = _data["l2id"];
            this.roadType = _data["roadType"];
            this.project = _data["project"];
            this.subResource = _data["project"];
        }
    }

    static fromJS(data: any): NoticeUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoticeUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["odinId"] = this.odinId;
        data["safeDigId"] = this.safeDigId;
        data["parentId"] = this.parentId;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["county"] = this.county;
        data["easting"] = this.easting;
        data["northing"] = this.northing;
        data["easting2"] = this.easting2;
        data["northing2"] = this.northing2;
        if (Array.isArray(this.worksLocations)) {
            data["worksLocations"] = [];
            for (let item of this.worksLocations)
                data["worksLocations"].push(item);
        }
        data["workDescription"] = this.workDescription;
        data["requestor"] = this.requestor;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        if (Array.isArray(this.tmType)) {
            data["tmType"] = [];
            for (let item of this.tmType)
                data["tmType"].push(item);
        }
        data["fwClosureType"] = this.fwClosureType;
        data["phaseType"] = this.phaseType;
        data["cancelReason"] = this.cancelReason;
        data["cancelNote"] = this.cancelNote;
        data["permitNumber"] = this.permitNumber;
        data["submissionDate"] = this.submissionDate;
        data["permitStatus"] = this.permitStatus;
        data["trafficSensitiveHours"] = this.trafficSensitiveHours;
        data["hoursOfWork"] = this.hoursOfWork;
        data["excavationRequired"] = this.excavationRequired;
        data["noticeStatus"] = this.noticeStatus;
        data["usrn"] = this.usrn;
        data["permitType"] = this.permitType;
        data["l2id"] = this.l2id;
        data["roadType"] = this.roadType;
        data["project"] = this.project;
        data["subResource"] = this.subResource;
        return data;
    }
}

export class NoticeUpdateHeaderDto implements INoticeUpdateHeaderDto {
    id?: number;
    odinId?: string | undefined;
    project?: number | undefined;
    l2Id?: string | undefined;

    constructor(data?: INoticeUpdateHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.odinId = _data["odinId"];
            this.project = _data["project"];
            this.l2Id = _data["l2Id"];
        }
    }

    static fromJS(data: any): NoticeUpdateHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoticeUpdateHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["odinId"] = this.odinId;
        data["project"] = this.project;
        data["l2Id"] = this.l2Id;
        return data;
    }
}

export interface INoticeUpdateHeaderDto {
    id?: number;
    odinId?: string | undefined;
    project?: number | undefined;
    l2Id?: string | undefined;
}

export interface INoticeCreateDto {
    odinId: string | undefined;
    safeDigId: number | undefined;
    parentId: number | undefined;
    address1: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    county: string | undefined;
    easting: number | undefined;
    northing: number | undefined;
    easting2: number | undefined;
    northing2: number | undefined;
    worksLocations: number[] | undefined;
    workDescription: string | undefined;
    requestor: string | undefined;
    startDate: MNullable<Date> | undefined;
    endDate: MNullable<Date> | undefined;
    tmType: number[] | undefined;
    fwClosureType: number | undefined;
    trafficSensitiveHours: number | undefined;
    hoursOfWork: string | undefined;
    excavationRequired: boolean | undefined;
    permitType: number | undefined;
    l2id?: string | undefined;
    project: number | undefined;
    subResource: number | undefined;
}

export interface INoticeUpdateDto {
    id: number | undefined;
    odinId: string | undefined;
    safeDigId: number | undefined;
    parentId: number | undefined;
    address1: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    county: string | undefined;
    easting: number | undefined;
    northing: number | undefined;
    easting2: number | undefined;
    northing2: number | undefined;
    worksLocations: number[] | undefined;
    workDescription: string | undefined;
    requestor: string | undefined;
    startDate: MNullable<Date> | undefined;
    endDate: MNullable<Date> | undefined;
    tmType: number[] | undefined;
    fwClosureType: number | undefined;
    phaseType: number | undefined;
    cancelReason: number | undefined;
    cancelNote: string | undefined;
    permitNumber: string | undefined;
    submissionDate?: MNullable<Date> | undefined;
    permitStatus: number | undefined;
    trafficSensitiveHours: number | undefined;
    hoursOfWork: string | undefined;
    excavationRequired?: boolean | undefined;
    noticeStatus: number | undefined;
    usrn?: string | undefined;
    permitType: number | undefined;
    l2id?: string | undefined;
    roadType: number | undefined;
    project: number | undefined;
    subResource: number | undefined;
}